import type { ViewerJobStatus } from "../../../types/viewerDeployment";
import type { ViewerDraftSyncState } from "./viewerDraftSyncState";

export interface ViewerAdminRuntimeUiState {
  blockingView: "none" | "loading" | "error";
  blockingErrorMessage: string | null;
  statusMessage: string | null;
}

interface ResolveViewerAdminRuntimeUiStateParams {
  shouldMountAdminDeploymentRuntime: boolean;
  adminRuntimeStatus: "idle" | "loading" | "ready" | "error";
  adminRuntimeError: string | null;
  deploymentError: string | null;
  jobStatus: ViewerJobStatus | null;
  draftSyncState: ViewerDraftSyncState;
}

const DEPLOY_QUEUED_MESSAGE =
  "Deploy queued. Waiting for the control plane to pick up the job.";
const DEPLOY_RUNNING_MESSAGE =
  "Deploy in progress. Live state will update when the job finishes.";

export function resolveViewerAdminRuntimeUiState(
  params: ResolveViewerAdminRuntimeUiStateParams,
): ViewerAdminRuntimeUiState {
  const {
    shouldMountAdminDeploymentRuntime,
    adminRuntimeStatus,
    adminRuntimeError,
    deploymentError,
    jobStatus,
    draftSyncState,
  } = params;

  const statusMessage =
    draftSyncState.saveStatus === "conflict"
      ? draftSyncState.conflictMessage
      : draftSyncState.saveStatus === "failed"
        ? draftSyncState.errorMessage
        : deploymentError
          ? deploymentError
          : jobStatus?.status === "queued"
            ? DEPLOY_QUEUED_MESSAGE
            : jobStatus?.status === "running"
              ? DEPLOY_RUNNING_MESSAGE
              : null;

  if (shouldMountAdminDeploymentRuntime && adminRuntimeStatus === "loading") {
    return {
      blockingView: "loading",
      blockingErrorMessage: null,
      statusMessage,
    };
  }

  if (
    shouldMountAdminDeploymentRuntime &&
    adminRuntimeStatus === "error" &&
    adminRuntimeError
  ) {
    return {
      blockingView: "error",
      blockingErrorMessage: adminRuntimeError,
      statusMessage,
    };
  }

  return {
    blockingView: "none",
    blockingErrorMessage: null,
    statusMessage,
  };
}
